import { createFileRoute } from '@tanstack/react-router';

import { getPatentOptions } from '@/module/Author/Patent';

export const Route = createFileRoute('/_auth/author/_author/patent/_patent/$patentId/_layout')({
  loader: async ({ params: { patentId }, context: { queryClient } }) => {
    const patent = await queryClient.ensureQueryData(getPatentOptions(patentId));

    return {
      patent,
      crumb: patent.title,
    };
  },
});
